import { toast } from "react-toastify";
import { getCustomers, getProducts } from "./callAPI";
import { objectToFullText } from "../lib/misc";
import moment from "moment";
import { CustomerStore, ProductStore } from "./db";
import Schema from "../type/schema";

export async function cacheCustomers() {
	try {
		const customers = await getCustomers({ limit: -1, page: 1 });
		localStorage.setItem("customers", JSON.stringify(customers.customers));
	} catch (e: any) {
		toast.error(`Lỗi cacheCustomers|${e.toString()}`);
	}
}

export function findCustomer(customerId: string) {
	try {
		const customers = JSON.parse(localStorage.getItem("customers")!);
		for (let c of customers!) {
			if (c.id === customerId) {
				return c;
			}
		}
	} catch (e: any) {
		toast.error("customers in LS error");
	}
}

export async function populateRentals(rentals: Schema.Rental[]) {
	const populatedList = await Promise.all(
		rentals.map(async (r, i) => {
			const customer = await CustomerStore.getItem(r.customerId);

			const status = r.isDone ? "Hoàn thành" : "Đang thuê";
			const formattedCreatedAt = moment.unix(+r.createdAt).format("YYYY-MM-DD");
			const formattedStartDate = moment.unix(+r.startDate).format("YYYY-MM-DD");
			const formattedDueDate = moment.unix(+r.dueDate).format("YYYY-MM-DD");
			const formattedReturnDate =
				r.returnDate != null
					? moment.unix(+r.returnDate).format("YYYY-MM-DD")
					: "";

			const populated = {
				...r,
				customer,
				status,
				formattedCreatedAt,
				formattedStartDate,
				formattedDueDate,
				formattedReturnDate
			};
			const fullText = objectToFullText(populated);

			return {
				...populated,
				fullText
			};
		})
	);

	return populatedList;
}

export async function populateProducts(numberOfRentalsByProduct: any) {
	const populatedList = await Promise.all(
		Object.keys(numberOfRentalsByProduct).map(async (pId: string) => {
			const product: any = await ProductStore.getItem(pId);
			if (!product) {
				return { id: pId };
			}
			const quantity = numberOfRentalsByProduct[pId];
			const populated = { ...product, quantity };

			const fullText = objectToFullText(populated);

			return { ...populated, fullText };
		})
	);

	return populatedList;
}

export async function populateCustomers(rentals: Schema.Rental[]): Promise<
	(Schema.Customer & {
		rentalCount: number;
		feeSum: number;
		depositSum: number;
		refundSum: number;
		lostItemsCount: number;
		itemRentedCount: number;
		formattedCreatedAt: string;
	})[]
> {
	const uniqueCustomerIds = Array.from(
		new Set(rentals.map((r) => r.customerId))
	);
	const populatedList: any[] = await Promise.all(
		uniqueCustomerIds.map(async (id) => {
			const customer = (await CustomerStore.getItem(id)) as Schema.Customer;
			const ownRentals = rentals.filter((r) => r.customerId === id);
			const rentalCount = ownRentals.length;
			const feeSum = ownRentals.reduce((acc, cur) => acc + cur.totalFee, 0);
			const depositSum = ownRentals.reduce((acc, cur) => acc + cur.deposit, 0);
			const refundSum = ownRentals.reduce(
				(acc, cur) => acc + cur.actualPayment,
				0
			);
			const lostItemsCount = ownRentals.reduce(
				(acc, cur) => acc + cur.lostItems.length,
				0
			);
			const itemRentedCount = ownRentals.reduce(
				(acc, cur) => acc + cur.items.length,
				0
			);
			const formattedCreatedAt =
				customer?.createdAt != null
					? moment.unix(+customer.createdAt).format("YYYY-MM-DD")
					: "";

			const formattedDob =
				customer?.dob != null
					? moment.unix(+customer.dob).format("YYYY-MM-DD")
					: "";

			const populated = {
				...customer,
				rentalCount,
				feeSum,
				depositSum,
				refundSum,
				lostItemsCount,
				itemRentedCount,
				formattedCreatedAt,
				formattedDob
			};

			const fullText = objectToFullText(populated);
			return { ...populated, fullText };
		})
	);

	return populatedList;
}

export async function cacheProducts1(
	cb?: (progress: number) => void,
	limit?: number
) {
	try {
		console.log("> Start caching products");
		await ProductStore.clearItems();

		const data = await getProducts({ page: 1, limit: -1 });
		if (limit) {
			data.products = data.products.slice(-limit);
		}
		await Promise.all(
			data.products.map(async (item: any, i, arr) => {
				await ProductStore.setItem(item.id, item);
				if (cb) {
					cb((i + 1) / arr.length);
				}
			})
		);
		console.log("< Finished caching products");
	} catch (e) {
		console.log("ERROR cacheProducts", e);
	}
}

export async function cacheCustomers1(
	cb?: (progress: number) => void,
	limit?: number
) {
	try {
		console.log("> Start caching customers");
		await CustomerStore.clearItems();

		const data = await getCustomers({ page: 1, limit: -1 });
		if (limit) {
			data.customers = data.customers.slice(-limit);
		}
		await Promise.all(
			data.customers.map(async (item: any, i, arr) => {
				await CustomerStore.setItem(item.id, item);
				if (cb) {
					cb((i + 1) / arr.length);
				}
			})
		);
		console.log("< Finished cache customers");
	} catch (e) {
		console.log("ERROR cacheCustomers", e);
	}
}

export function findCustomer1(customerId: string) {
	return CustomerStore.getItem(customerId);
}
